/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const fieldMappingUsageSchema = z.object({
  instanceFieldMappingId: z.int(),
  integrationIds: z.array(z.int()),
});
